<template>
  <div class="dark:bg-ontick-carbon-500 absolute inset-0 flex bg-gray-50 md:pb-0">
    <sidebar
      :compress_sidebar="status_sidebar"
      :nav="nav"
      :active_stream="active_stream"
      @active_stream="active_stream = !active_stream"
    />

    <div class="relative flex w-0 flex-1 flex-col overflow-hidden">
      <!-- <navbar
        :uiTheme="config.ui_theme"
        :userName="config.user_name"
        :userPicture="config.user_picture"
        :userCode="config.user_code"
        @compressMobile="status_sidebar = !status_sidebar"
        @minimizeMobile="minimize_sidebar = !minimize_sidebar"
      ></navbar> -->
      <main class="relative flex-1 overflow-y-auto focus:outline-none">
        <notification-urgent />
        <vue-page-transition name="fade-in-right" class="h-full" id="div-vue-page-transition">
          <router-view :key="key"></router-view>
        </vue-page-transition>
      </main>

      <transition
        enter-active-class="transform-gpu transition ease-in-out duration-500  "
        enter-class="translate-y-full"
        enter-to-class="translate-y-0"
        leave-active-class="transform-gpu transition ease-in-out duration-500 "
        leave-class="translate-y-0"
        leave-to-class="translate-y-full"
      >
        <stream v-if="active_stream" :active_stream="active_stream" @close="active_stream = false" />
      </transition>
      <!-- <ticker-component class="relative" /> -->
      <placeholder-offline />
      <!-- <sidebar-menu-mobile-component
        :compress_sidebar="status_sidebar"
        :nav="nav"
        class="fixed bottom-0 left-0 z-30 w-full"
      /> -->
      <mobile-navbar-component :nav="nav" class="lg:hidden" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "container",

  components: {
    Stream: () => import("../../../modules/stream/pages/stream.component.vue"),
    Sidebar: () => import("../sidebar/sidebar.component.vue"),
    Loading: () => import("../loading/loading.component"),
    PlaceholderOffline: () => import("../placeholder/placeholder-offline.component.vue"),
    TickerComponent: () => import("../ticker/ticker.component.vue"),
    SidebarMenuMobileComponent: () => import("../sidebar/sidebar-mobile/sidebar-menu-mobile.component.vue"),
    NotificationUrgent: () => import("@/app/modules/notification/components/notification-urgent.component"),
    MobileNavbarComponent: () => import("../sidebar/sidebar-mobile/mobile-navbar.component.vue"),
  },

  data() {
    return {
      accounts_initialized: false,
      notify: null,
      online: true,
      status_sidebar: window.location.hostname ? true : false,
      minimize_sidebar: false,
      num_running: 0,
      active_stream: false,
      url: false,
      key: 9999,
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
    nav() {
      let sideMenus = [];

      if (this.getConfigs.side_menus !== undefined) {
        sideMenus = this.getConfigs.side_menus.map((item) => item.menu_name);
      }

      return [
        {
          title: "Dashboard",
          active: false,
          url: "/",
          icon: this.$icons.dashboard,
          visible: true,
        },
        {
          title: "Estratégias",
          truncatedTitle: "Estrat.",
          active: false,
          url: "/marketplace",
          icon: this.$icons.marketplace,
          visible: true,
        },
        {
          title: "Investimentos",
          truncatedTitle: "Invest.",
          active: false,
          url: "/investments",
          icon: this.$icons.investments,
          visible: true,
        },
        {
          title: "Long & Short",
          // truncatedTitle: "Invest.",
          active: false,
          url: "/longshort",
          icon: this.$icons.longshort,
          visible: sideMenus.includes("Long & Short"),
        },
        // {
        //   title: "Trade Ideas",
        //   // truncatedTitle: "Invest.",
        //   active: false,
        //   url: "/trade-ideas",
        //   icon: this.$icons.trade_ideas,
        //   // visible: this.getConfigs.user_type === "ADMIN",
        //   visible: sideMenus.includes("Trade Ideas"),
        // },
        {
          title: "Trade Ideas",
          active: false,
          url: "/trade-ideas-v2",
          icon: this.$icons.trade_ideas,
          visible: sideMenus.includes("Trade Ideas"),
        },
        {
          title: "Histórico",
          active: false,
          url: "/history",
          icon: this.$icons.performance,
          visible: true,
        },
        {
          title: "Analistas XP",
          truncatedTitle: "Analistas XP",
          active: false,
          url: "/marketplace/analistas_xp",
          icon: this.$icons.sidebar_person,
          visible: true,
        },
        {
          title: "Ranking",
          active: false,
          url: "/ranking",
          icon: this.$icons.crown_stroke,
          visible: true,
        },
        {
          title: "Parceiros",
          active: false,
          url: "/partners",
          icon: this.$icons.handshake,
          visible: this.getConfigs.user_type === "ADMIN" || this.getSelectedAccount.account_type !== "CONTEST",
        },
        // {
        //   title: "Best",
        //   active: false,
        //   url: "/bests",
        //   icon: this.$icons.best_menu,
        //   visible:
        //     this.getConfigs.user_type === "ADMIN" ||
        //     sideMenus.includes("Bests") ||
        //     this.getSelectedAccount.broker_name == "RICO",
        // },
      ];
    },
  },

  methods: {
    generateKey() {
      this.key = Math.floor(Math.random() * 1000);
    },
  },

  watch: {
    getConfigs: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (this.$route.name !== undefined && this.$route.name === "Trade Ideas v2") {
          let sideMenus = [];

          if (newValue.side_menus !== undefined) {
            sideMenus = newValue.side_menus.map((item) => item.menu_name);
          }

          if (!sideMenus.includes("Trade Ideas")) {
            this.$router.replace({ name: "Dashboard" });
          }
        }
      },
    },

    active_stream: {
      handler(value) {
        localStorage.setItem("stream", value);
      },
    },
    // getSelectedAccount: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     let index = this.nav.findIndex((item) => item.title === "Parceiros");
    //     this.nav[index].visible = val.account_type !== "CONTEST";
    //   },
    // },
    $route: {
      immediate: true,
      deep: true,
      handler(newRoute, oldRoute) {
        if (["Marketplace", "Analistas XP"].includes(newRoute.name) && newRoute.name !== oldRoute.name) {
          this.generateKey();
        }
      },
    },
    // getSelectedAccount: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     let index = this.nav.findIndex((item) => item.title === "Parceiros");
    //     this.nav[index].visible = val.account_type !== "CONTEST";
    //   },
    // },
  },

  created() {
    this.active_stream = localStorage.getItem("stream") == "true" ? true : false;
  },
};
</script>
